import { Dialog, DialogContainer, Heading, Divider, Content, Text, ButtonGroup, Button } from "@adobe/react-spectrum";
import { useEffect, useState } from "react";
import { Alert } from "../Icons";

/**
 * Check if the browser is Chrome or Edge
 * @returns {boolean} true if the browser is Chrome or Edge, false otherwise
 */
function isSupportedBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (userAgent.includes('chrome') && !userAgent.includes('edg') && !userAgent.includes('opr')) || 
           userAgent.includes('edg');
}

/**
 * Opens Chrome browser download page
 */
export function openChromeBrowser() {
    // Always direct users to the Chrome download page
    window.open('https://www.google.com/chrome/', '_blank');
}

export default function BrowserSupport() {
    const [showBrowserWarning, setShowBrowserWarning] = useState(false);

    useEffect(() => {
        if (!isSupportedBrowser()) {
            setShowBrowserWarning(true);
        }
    }, []);

    return (
        <DialogContainer isDismissable={false} onDismiss={() => { }}>
            {showBrowserWarning &&
                <Dialog isDismissable={false}>
                    <Heading level={4}>
                        <span>
                            <span
                                style={{
                                    marginRight: '15px',
                                }}
                            >
                                <Alert />
                            </span>
                            <span>Unsupported Browser</span>
                        </span>
                    </Heading>
                    <Divider />
                    <Content>
                        <Text>
                            <b>iHub is currently supported only on Google Chrome/Edge.</b> Please use Google Chrome/Edge to access this application.
                        </Text>
                    </Content>
                    <ButtonGroup>
                        <Button
                            variant="cta"
                            onPress={() => openChromeBrowser()}
                        >
                            Download Chrome
                        </Button>
                    </ButtonGroup>
                </Dialog>
            }
        </DialogContainer>
    )
}